import createStyleSyncService from './services/styleSyncService';

const UNITS = [
    { value: 'px', name: 'px' },
    { value: '%', name: '%' },
    { value: 'em', name: 'em' },
    { value: 'rem', name: 'rem' },
    { value: 'vw', name: 'vw' },
    { value: 'vh', name: 'vh' },
    { value: 'vmin', name: 'vmin' },
    { value: 'vmax', name: 'vmax' },
    { value: 'fr', name: 'fr' },
    { value: 'ch', name: 'ch' },
    { value: 'auto', name: 'auto' },
];

function parseValueWithUnit(str) {
    if (!str || typeof str !== 'string') return { value: '', unit: 'px' };
    const trimmed = str.trim();
    if (trimmed === 'auto') return { value: 'auto', unit: 'auto' };
    const match = trimmed.match(/^(-?\d*\.?\d+)(px|%|em|rem|vw|vh|vmin|vmax|fr|ch)?$/i);
    if (match) return { value: match[1], unit: match[2] || 'px' };
    return { value: trimmed, unit: 'px' };
}

export default (editor, config = {}) => {
    const tm = editor.TraitManager;
    const styleSyncService = createStyleSyncService(editor);

    tm.addType('size-with-unit', {
        createInput({ trait }) {
            const component = trait.target;
            const property = trait.get('property') || 'width';
            const labelText = trait.get('displayLabel') || 'Width';

            const rawValue = styleSyncService.readPropertyValue({ component, property, unit: '' });
            const { value: currentValue, unit: currentUnit } = parseValueWithUnit(rawValue);

            const wrapper = document.createElement('div');
            wrapper.style.cssText = 'display:flex;flex-direction:column;gap:4px;width:100%;margin-top:4px;margin-bottom:4px;';

            const title = document.createElement('div');
            title.textContent = labelText;
            title.style.cssText = 'font-size:14px;line-height:1.3;margin:4px 0;';
            title.classList.add("gjs-label-wrp")

            const controlsRow = document.createElement('div');
            controlsRow.style.cssText = 'display:flex;align-items:center;gap:6px;width:100%;';

            const input = document.createElement('input');
            input.type = 'text';
            input.placeholder = currentUnit === 'auto' ? 'auto' : '0';
            input.value = currentValue;
            input.style.cssText = 'flex:1;min-width:0;border:1px solid #444;border-radius:4px;color:#fff;font-size:14px;padding:4px 8px;outline:none;';

            const unitSelect = document.createElement('select');
            unitSelect.style.cssText = 'width:70px;border:1px solid #444;border-radius:4px;color:#fff;font-size:13px;padding:4px 6px;outline:none;cursor:pointer;';
            UNITS.forEach((u) => {
                const opt = document.createElement('option');
                opt.value = u.value;
                opt.textContent = u.name;
                if (u.value === currentUnit) opt.selected = true;
                unitSelect.appendChild(opt);
            });

            const syncFromStyles = () => {
                const raw = styleSyncService.readPropertyValue({ component, property, unit: '' });
                const { value, unit } = parseValueWithUnit(raw);
                input.value = value;
                input.placeholder = unit === 'auto' ? 'auto' : '0';
                input.disabled = unit === 'auto';
                const hasUnit = UNITS.some((u) => u.value === unit);
                if (hasUnit) unitSelect.value = unit;
            };

            const applyValue = () => {
                const unit = unitSelect.value;
                const val = input.value.trim();
                if (unit === 'auto') {
                    styleSyncService.applyStyleValue({ component, property, value: 'auto' });
                    input.value = '';
                    input.disabled = true;
                    return;
                }
                input.disabled = false;
                if (val === '' || val === '-') return;
                const num = parseFloat(val);
                if (!Number.isFinite(num)) return;
                styleSyncService.applyStyleValue({
                    component,
                    property,
                    value: `${val}${unit}`,
                });
            };

            if (currentUnit === 'auto') {
                input.disabled = true;
                input.value = '';
            }

            wrapper._unsubscribeDeviceChange = styleSyncService.subscribeToDeviceChangesForElement({
                element: wrapper,
                onChange: syncFromStyles,
            });

            input.addEventListener('change', applyValue);
            input.addEventListener('blur', applyValue);
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    applyValue();
                }
            });
            unitSelect.addEventListener('change', () => {
                if (unitSelect.value === 'auto') {
                    input.disabled = true;
                    input.value = '';
                    styleSyncService.applyStyleValue({ component, property, value: 'auto' });
                } else {
                    input.disabled = false;
                    applyValue();
                }
            });

            controlsRow.append(input, unitSelect);
            wrapper.append(title, controlsRow);
            wrapper._input = input;
            wrapper._unitSelect = unitSelect;
            wrapper._property = property;
            wrapper._syncFromStyles = syncFromStyles;

            return wrapper;
        },

        onUpdate({ elInput, component, trait }) {
            if (!elInput._syncFromStyles) return;
            elInput._syncFromStyles();
        },

        onEvent() {},
    });
};
